module.exports = __webpack_public_path__ + "static/media/wonder_ends_opacity.2dd7fe44.png";